module.exports = __webpack_public_path__ + "img/arrow-pagination.653526f2.svg";